import { IModelAssignmentResponse } from '@kcftech/prometheustypescriptapiclient';
import { GroupHierarchyText } from 'components/group_hierarchy/GroupHierarchyText';
import { StatelessPopup } from 'components/popup/stateless_popup/StatelessPopup';
import { SpinnerArea } from 'components/spinner/SpinnerArea';
import { Tag } from 'components/tag/Tag';
import { useTreeItems } from 'custom_hooks/data_hooks/tree/useTreeItems';
import { usePopup } from 'custom_hooks/usePopup';
import styled from 'styled-components';

const AssignedGroupsList = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    overflow-y: auto;
    max-height: 30rem;
    max-width: 70rem;
    background: var(--background-paper-elevation-8);
    color: var(--text-primary);
    padding: 0.75rem;
`;

const AssignedGroups = styled.div`
    gap: 0.25rem;
    padding: 0.75rem;
`;

export type AssignedModelGroupProps = Readonly<{
    rowData: IModelAssignmentResponse;
}>;

export function AssignedModelGroups({ rowData }: AssignedModelGroupProps) {
    const { isOpen, open, close, triggerRef, popupRef } = usePopup();

    const { isLoading, data } = useTreeItems(rowData.AssignedGroupIds);
    const assignedGroupsLength = rowData.AssignedGroupIds.length;

    return (
        <div>
            {assignedGroupsLength > 0 ? (
                <Tag onSelect={open} selected={isOpen}>
                    <span ref={triggerRef}>
                        {assignedGroupsLength}{' '}
                        {assignedGroupsLength === 1 ? 'Assignment' : 'Assignments'}
                    </span>
                </Tag>
            ) : (
                <Tag>No Assignments</Tag>
            )}
            {isOpen && assignedGroupsLength > 0 && (
                <StatelessPopup
                    noPadding
                    ref={popupRef}
                    anchor={triggerRef.current}
                    anchorAlign={{ horizontal: 'left', vertical: 'bottom' }}
                    popupAlign={{ horizontal: 'right', vertical: 'top' }}
                    popupClassName="modal-popup"
                    onClose={close}
                >
                    <AssignedGroupsList>
                        <SpinnerArea isLoading={isLoading}>
                            {data?.map((item) => (
                                <AssignedGroups key={item.Id}>
                                    {item.Hierarchy.length > 0 ? (
                                        <GroupHierarchyText
                                            hierarchy={item.Hierarchy}
                                            suffix={item.Name}
                                        />
                                    ) : (
                                        <div className="bold text-nowrap">
                                            {item.Name}
                                        </div>
                                    )}
                                </AssignedGroups>
                            ))}
                        </SpinnerArea>
                    </AssignedGroupsList>
                </StatelessPopup>
            )}
        </div>
    );
}
